/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web-dotcom-node'
 *
 * Required dependencies: @amplitude/analytics-node@^1.0.0
 * Tracking Plan Version: 4
 * Build: 1.0.0
 * Runtime: node.js:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/agreena/Supply%20Chain%20-%20Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/agreena/Supply%20Chain%20-%20Production/implementation/web-dotcom-node)
 */

import * as amplitude from "@amplitude/analytics-node";

export type NodeClient = amplitude.Types.NodeClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
export type NodeOptions = amplitude.Types.NodeOptions;

export type Environment = "supplychainproduction";

export const ApiKey: Record<Environment, string> = {
  supplychainproduction: "8680aedc2402aabf316017351827a9cf",
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: NodeOptions = {
  plan: {
    version: "4",
    branch: "main",
    source: "web-dotcom-node",
    versionId: "f76e4d52-ca03-4cfc-9d72-2bb8703b8e0e",
  },
  ...{
    ingestionMetadata: {
      sourceName: "node.js-typescript-ampli",
      sourceVersion: "2.0.0",
    },
  },
  serverZone: amplitude.Types.ServerZone.EU,
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: NodeOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: NodeOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: NodeClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * Indicates the % of hectares that had cover crops last year.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  CoverCropScore?: number;
  email?: string;
  /**
   * *Hectares under Management.*
   *
   * Amount of hectares the farmer has that are enrolled into Agreena monetisation agreement.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   */
  HuM?: number;
  /**
   * *Hectares under Service*
   *
   * Amount of hectares the farmer has that could potentially be enrolled into Agreena monetisation agreement.
   *  (some or all of it might be enrolled already, check HuM property)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   */
  HuS?: number;
  /**
   * Used on Insights RegenAg Score Report page to send the user score
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  RegenAgScore?: number;
  /**
   * Indicates the % of hectares that were reduced or no-till accross the whole farm last year.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   * | Min Value | 0 |
   * | Max Value | 100 |
   */
  TillageScore?: number;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled = false;
  private amplitude?: NodeClient;

  get client(): NodeClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error(
        "ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?",
      );
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn(
        "WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.",
      );
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && "apiKey" in options.client) {
      apiKey = options.client.apiKey;
    } else if ("environment" in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && "instance" in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration =
        options.client && "configuration" in options.client
          ? options.client.configuration
          : {};
      return this.amplitude.init(apiKey, {
        ...DefaultConfiguration,
        ...configuration,
      });
    } else {
      console.error(
        "ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'",
      );
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = { ...options, user_id: userId };
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }

    return this.amplitude?.identify(amplitudeIdentify, options);
  }

  /**
   * Track event
   *
   * @param userId The user's id.
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(
    userId: string | undefined,
    event: Event,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = { ...options, user_id: userId };
    }

    return this.amplitude?.track(event, undefined, options);
  }

  flush(): PromiseResult<void> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude?.flush();
  }
}

export const ampli = new Ampli();
